import { resolve } from 'node:path'
import { stat } from 'node:fs/promises'
import { Command } from 'commander'
import { findManifest } from '../vpkg/manifest.js'
import { readManifestDocument, validateManifest } from '../dev/manifest.js'

export function registerValidate(program: Command): void {
  program
    .command('validate [pathOrDir]')
    .description('Validate an engine/app/bundle manifest (structure + registration-time checks)')
    .action(async (pathOrDir: string | undefined) => {
      const target = resolve(pathOrDir ?? '.')
      const info = await stat(target).catch(() => null)
      const manifestPath = info?.isDirectory() ? await findManifest(target) : target
      if (!info) throw new Error(`${target} does not exist.`)

      const manifest = await readManifestDocument(manifestPath)
      const issues = validateManifest(manifest)
      const errors = issues.filter((issue) => issue.level === 'error')
      const warnings = issues.filter((issue) => issue.level === 'warning')

      console.log(`${manifestPath} — kind ${manifest.kind ?? '(unknown)'}, ${manifest.metadata?.name ?? '?'}@${manifest.metadata?.version ?? '?'}`)
      for (const issue of errors) console.error(`  error: ${issue.message}`)
      for (const issue of warnings) console.warn(`  warning: ${issue.message}`)

      if (errors.length === 0) {
        console.log(warnings.length > 0 ? `OK with ${warnings.length} warning(s).` : 'OK.')
      } else {
        console.error(`${errors.length} error(s).`)
        process.exitCode = 1
      }
    })
}
